import { render, staticRenderFns } from "./MissingPositionWarning.vue?vue&type=template&id=a4e01102"
import script from "./MissingPositionWarning.vue?vue&type=script&lang=js"
export * from "./MissingPositionWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports